var E = /* @__PURE__ */ ((s) => (s.DEFAULT = "default", s.PODCAST = "podcast", s.SERIES = "series", s.SLIDESHOW = "slideshow", s.VIDEO = "video", s))(E || {});
export {
  E as RocheUIStoryType
};
